/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/11/22
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {GoogleEvent} from "../../interfaces/Global";
import {persistState} from "../helpers";

export type GoogleEventsState = GoogleEvent[];

const STORAGE_KEY = 'vega.state.google-events';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: GoogleEventsState = storedState ? JSON.parse(storedState) : [];

export const slice = createSlice({
	name: 'google-events',
	initialState: initialState as GoogleEventsState,
	reducers: {
		set: (state, action: PayloadAction<GoogleEventsState>) => {
			persistState(STORAGE_KEY, action.payload);
			return action.payload;
		},
	},
});

export const {set} = slice.actions;
export default slice.reducer;